const reLettersOnly = /^[a-zA-Z]*$/;

export const onlyLetters = (text: string): boolean => reLettersOnly.test(text);
